import { addObject3DComponent } from "../utils/jsx-entity";
import { NetworkedMediaFrame, SnapFrame } from "../bit-components";
import { addComponent, addEntity } from "bitecs";
import { MediaType } from "../utils/media-utils";
import { COLLISION_LAYERS } from "../constants";
import { Layers } from "../camera-layers";
import { inflateRigidBody, Type } from "./rigid-body";
import { Fit, inflatePhysicsShape, Shape } from "./physics-shape";
import { getThemeColor } from "../utils/theme";
import { Color, DoubleSide } from "three";

const DEFAULTS = {
  bounds: { x: 1, y: 1, z: 1 },
  mediaType: "all"
};
export function inflateSnappeable(world, eid, componentProps) {
  componentProps = Object.assign({}, DEFAULTS, componentProps);
  const primaryColor = getThemeColor("primary-color");

  const colliderMaterial = new THREE.ShaderMaterial({
    uniforms: {
      color: { value: new Color(parseInt(`0x${primaryColor.replace("#", "")}`)) }
    },
    vertexShader: `
            varying vec2 vUv;
            void main()
            {
              gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );
              vUv = uv;
            }
          `,
    fragmentShader: `
            // adapted from https://www.shadertoy.com/view/Mlt3z8
            float bayerDither2x2( vec2 v ) {
              return mod( 3.0 * v.y + 2.0 * v.x, 4.0 );
            }
            float bayerDither4x4( vec2 v ) {
              vec2 P1 = mod( v, 2.0 );
              vec2 P2 = mod( floor( 0.5  * v ), 2.0 );
              return 4.0 * bayerDither2x2( P1 ) + bayerDither2x2( P2 );
            }

            varying vec2 vUv;
            uniform vec3 color;
            void main() {
              float alpha = max(step(0.45, abs(vUv.x - 0.5)), step(0.45, abs(vUv.y - 0.5))) - 0.5;
              if( ( bayerDither4x4( floor( mod( gl_FragCoord.xy, 4.0 ) ) ) ) / 16.0 >= alpha ) discard;
              gl_FragColor = vec4(color, 1.0);
            }
          `,
    side: DoubleSide
  });

  const invisibleMaterial = new THREE.ShaderMaterial({
    vertexShader: `void main() { gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0); }`,
    fragmentShader: `void main() { discard; }`, // Discard all pixels
    transparent: true
  });

  const guide = new THREE.Group();

  const offsetGeometry = new THREE.BoxGeometry(1, 1, 1); // Slightly larger geometry for the offset
  const offsetObject = new THREE.Mesh(offsetGeometry, colliderMaterial);
  guide.add(offsetObject);

  // Create a plane object inside the collider
  const planeGeometry = new THREE.PlaneGeometry(1, 1); // Plane geometry for the inner plane
  planeGeometry.name = "plane";
  const planeObject = new THREE.Mesh(planeGeometry, invisibleMaterial);
  planeObject.position.set(0, 0, -0.5);
  guide.add(planeObject);

  guide.layers.set(Layers.CAMERA_LAYER_UI);
  guide.parent = new THREE.Group();
  const guideEid = addEntity(world);
  addObject3DComponent(world, guideEid, guide);
  addComponent(world, SnapFrame, eid, true);
  addComponent(world, NetworkedMediaFrame, eid, true);

  SnapFrame.mediaType[eid] = {
    all: MediaType.ALL,
    "all-2d": MediaType.ALL_2D,
    model: MediaType.MODEL,
    image: MediaType.IMAGE,
    video: MediaType.VIDEO,
    pdf: MediaType.PDF
  }[componentProps.mediaType];
  SnapFrame.bounds[eid].set([componentProps.bounds.x, componentProps.bounds.y, componentProps.bounds.z]);
  SnapFrame.guide[eid] = guideEid;

  guide.visible = true;

  inflateRigidBody(world, eid, {
    type: Type.KINEMATIC,
    collisionGroup: COLLISION_LAYERS.MEDIA_FRAMES,
    collisionMask: COLLISION_LAYERS.INTERACTABLES,
    disableCollision: true
  });
  inflatePhysicsShape(world, eid, {
    type: Shape.BOX,
    fit: Fit.MANUAL,
    halfExtents: [0.5, 1, 0.5],
    includeInvisible: true
  });
}
